// definition types
import {PropertyValueType} from '~/shared/src/mm/PropertySet';

export type FieldsDefinition = {
    [ attributeName : string ] : string;
}

export type FieldTypesDefinition = {
    // mapping between attribute name and database field type
    [ attributeName : string ] : PropertyValueType;
}

export type TableDefinition = {
    // The table name in the database
    table : string;

    // The mapping between attribute names and database fields of the 'active' table
    fieldMap : FieldsDefinition;

    // The mapping between attribute names and database fields of the 'history' table
    historyFieldMap? : FieldsDefinition;

    // The mapping between attribute names and database field types of both 'active' and 'history' table
    fieldTypesMap? : FieldTypesDefinition;

    // Exists a generic view for the table
    hasView? : boolean;
    // The prefix for the table to resolve the generic view with
    viewPrefix? : string;

    // Exists a view for the status 'active' of the table
    hasActiveView? : boolean;
    // The prefix for the table to resolve the 'active' view with
    activeViewPrefix? : string;

    // Exists a view for the status 'active' and 'planned' of the table
    hasActivePlannedView? : boolean;
    // The prefix for the table to resolve the 'active' and 'planned' view with
    activePlannedViewPrefix? : string;

    // Exists a view for the status 'active', 'planned' and 'template' of the table
    hasActivePlannedTemplateView? : boolean;
    // The prefix for the table to resolve the 'active', 'planned' and 'template' view with
    activePlannedTemplateViewPrefix? : string;

    // Exists a view for the status 'planned' of the table
    hasPlannedView? : boolean;
    // The prefix for the table to resolve the 'planned' view with
    plannedViewPrefix? : string;

    // Exists a view for the status 'template' of the table
    hasTemplateView? : boolean;
    // The prefix for the table to resolve the 'template' view with
    templateViewPrefix? : string;

    // Exists a view for the import table of the table
    hasImportedView? : boolean;
    // The prefix for the table to resolve the 'imported' view with
    importedViewPrefix? : string;

    // Exists a history table for the table
    hasHistoryTable? : boolean;
    // The prefix for the table to resolve the history table with
    historyTablePrefix? : string;
    // Exists a history view for the table
    hasHistoryView? : boolean;
    // The prefix for the table to resolve the history view with
    historyViewPrefix? : string;
    // Exists a history snapshot view for the table
    hasHistorySnapshot? : boolean;
    // The prefix for the table to resolve the history snapshot view with
    historySnapshotPrefix? : string;
}

export type TablesDefinition = {
    [ tableName : string ] : TableDefinition;
}

export type SchemaDefinition = {
    tables : TablesDefinition;
}

export type SchemasDefinition = {
    [ schemaName : string ] : SchemaDefinition;
}

export type DbDefinition = {
    schemas : SchemasDefinition;
}

class DbDefinitionMapperUtilities {

    status : Status | 'allNonHistory' | undefined;
    isHistoryRequest : boolean | undefined;
    noHistorySnapshot : boolean | undefined;

}

const dbDefinitionMapperUtilities = new DbDefinitionMapperUtilities();
export default dbDefinitionMapperUtilities;
